import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import styled from 'styled-components';

type IAmountInputProps = {
  value?: number[];
  onChange?: (value: number[]) => void;
};

const AmountInput = ({ value, onChange }: IAmountInputProps) => {
  const minValue = value?.[0]?.toString();
  const maxValue = value?.[1]?.toString();

  const setValueMin = (newValue: number) => {
    onChange?.([newValue, value?.[1] ?? 0]);
  };
  const setValueMax = (newValue: number) => {
    onChange?.([value?.[0] ?? 0, newValue]);
  };
  return (
    <WrapperInput>
      <div className='label'>Amount</div>
      <Container>
        <span className='label'>From:</span>
        <CurrencyInputPrecision
          textAlign='left'
          height={'3.5rem'}
          value={minValue}
          onChange={setValueMin}
          bordered={false}
        />
        <span className='label'>To:</span>
        <CurrencyInputPrecision
          textAlign='left'
          height={'3.5rem'}
          value={maxValue}
          onChange={setValueMax}
          bordered={false}
        />
      </Container>
    </WrapperInput>
  );
};

export default AmountInput;

const WrapperInput = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  .label {
    color: #1d2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const Container = styled.div`
  height: 56px;
  display: flex;
  gap: 8px;
  padding: 0 10px;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #86909c;
  background: #fff;
  .label {
    color: #64748b;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`;
